import { AutocompleteType } from './autocomplete';

export type InputType = 'text';

export interface IDateRangeField {
  inputType: InputType;
}

export class DateRangeField implements IDateRangeField {
  inputType: InputType = 'text';
  autocomplete: AutocompleteType = 'off';

  constructor(configOverride?: Partial<IDateRangeField>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
